// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { gql } from 'apollo-angular';

export const projectCommitteeCategoriesQuery = gql`
  query projectsCommitteeCategory {
    projectsCommitteeCategory
  }
`;
